import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/Postback.css';

const Postback = () => {
    const navigate = useNavigate();

    // --- State ---
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [globalPostback, setGlobalPostback] = useState('');
    const [updateLoading, setUpdateLoading] = useState(false);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- Fetch Data ---
    useEffect(() => {
        const authToken = getCookie('authToken');
        const fetchData = async () => {
            try {
                setLoading(true);

                // 1. Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', { 
                    action: 'checkAuth', 
                    authToken 
                });

                if (!authRes.data.status) {
                    navigate('/login');
                    return;
                }
                setUser(authRes.data.res);

                // 2. Get Current Global Postback
                const pbRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'getGlobalPostback',
                    authToken
                });

                if (pbRes.data.status) {
                    setGlobalPostback(pbRes.data.url || '');
                }

            } catch (error) {
                toast.error('Failed to load postback data');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [navigate]);

    // --- Update Action ---
    const handleUpdate = async () => {
        if (!globalPostback.trim()) return toast.warning('Please enter a valid URL');

        setUpdateLoading(true);
        const authToken = getCookie('authToken');
        try {
            const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'updateGlobalPostback',
                authToken,
                url: globalPostback
            });

            if (res.data.status) {
                toast.success('Global Postback Updated!');
            } else {
                toast.error(res.data.message || 'Update failed');
            }
        } catch (err) {
            toast.error('Network Error');
        } finally {
            setUpdateLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="pb-page-wrapper-unique">
            <div className="bg-shape-pb shape-1-pb"></div>
            <div className="bg-shape-pb shape-2-pb"></div>
            <Navbar name={user?.name} role={user?.role} />

            <div className="pb-container-unique">
                
                <div className="pb-header-unique">
                    <h2>Global Postback Configuration</h2>
                    <p>Manage your global callback URL for real-time conversion notifications.</p>
                </div>

                {/* --- Update Card --- */}
                <div className="pb-card-unique main-card">
                    <div className="form-section">
                        <label className="pb-label">Postback URL</label>
                        <div className="input-group-pb">
                            <span className="icon-pb">🔗</span>
                            <input 
                                type="text" 
                                placeholder="https://your-tracker.com/postback?clickid={aff_click_id}" 
                                value={globalPostback}
                                onChange={(e) => setGlobalPostback(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="action-row-unique">
                        <button 
                            className="action-btn-black-wave update" 
                            onClick={handleUpdate} 
                            disabled={updateLoading}
                            style={{width: '100%'}}
                        >
                            {updateLoading ? 'SAVING...' : 'UPDATE POSTBACK'}
                        </button>
                    </div>
                </div>

                {/* --- Macros Reference --- */}
                <div className="pb-card-unique macros-card">
                    <h3 className="card-title-pb">Available Macros</h3>
                    <p className="macros-desc">Use these placeholders in your URL. They will be replaced dynamically.</p>
                    
                    <div className="macros-grid-unique">
                        <MacroItem name="{aff_click_id}" desc="Your unique Click ID" />
                        <MacroItem name="{sub_aff_id}" desc="Your unique Click ID 2" />
                        <MacroItem name="{camp_id}" desc="ID of the converted offer" />
                        <MacroItem name="{event}" desc="Event / goal name" />
                        <MacroItem name="{aff_sub1}....{aff_sub6}" desc="Custom params to pass extra details" />
                        <MacroItem name="{ip}" desc="Click IP Address" />
                        <MacroItem name="{device}" desc="User Device Type" />
                    </div>
                </div>

            </div>
        </div>
    );
};

// Helper for Macros
const MacroItem = ({ name, desc }) => (
    <div className="macro-item-unique">
        <span className="macro-tag">{name}</span>
        <span className="macro-info">{desc}</span>
    </div>
);

export default Postback;